<template>
  <div class="flat-card-wrapper">
    <div class="flat-card">
      <div class="flat-card__img-wrapper">
        <img
          :src="flatImg"
          alt=""
          width="100%"
          height="100%"
          class="flat-card__img"
        />
        <PlanDiscountLabel :data="data" class="flat-card__discount" />
      </div>
      <div class="flat-card__content">
        <div class="flat-card__content-header">
          <div class="flats-card__rooms">
            <p class="flats-card__rooms-header">{{ roomCount }}</p>
            <span> №{{ flatNumber }}, корпус {{ flatBuilding }} </span>
          </div>
          <div class="flat-card__buttons">
            <!-- <DocsButton
              v-if="
                data?.discount || data?.properties?.reverse_discount_percent > 0
              "
            /> -->
            <slot name="favorite" />
          </div>
        </div>
        <slot name="tags" />
        <div class="flat-card__content-description">
          <div class="flats-card__area">
            <span>Площадь</span>
            <div class="flat-card__content-line" />
            <span v-html="flatArea" />
          </div>
          <div class="flats-card__floor">
            <span>Этаж</span>
            <div class="flat-card__content-line" />
            <span>{{ flatFloor }}</span>
          </div>
          <div class="flats-card__mortgage">
            <span>Ипотека</span>
            <div class="flat-card__content-line" />
            <span>от {{ flatMortgage }}</span>
          </div>
          <div class="flats-card__cost">
            <span>Стоимость</span>
            <div class="flat-card__content-line" />
            <template v-if="data?.properties?.reverse_discount_percent > 0">
              <span class="flats-card__new-price">
                {{ $filters.priceFormat(getFlatCosts(data).cost) }}
              </span>
              <span
                v-if="getFlatCosts(data).oldCost"
                class="flats-card__old-price"
              >
                {{ $filters.priceFormat(getFlatCosts(data).oldCost) }}
              </span>
            </template>
            <template v-else>
              <span :class="{ 'flats-card__old-price': data?.discount }">
                {{ flatCost }}
              </span>
              <span v-if="data?.discount" class="flats-card__new-price">
                {{ $filters.priceFormat(data.discount_cost) }}
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReversPercentCost } from '@/utils/getReversPercentCost'
import PlanDiscountLabel from "@/components/PlanDiscountLabel.vue";
// import DocsButton from "@/components/UI/DocsButton.vue";
export default {
  components: {
    PlanDiscountLabel,
    // DocsButton,
  },
  props: {
    flatImg: {
      type: String,
      default: "",
    },
    roomCount: {
      type: String,
      default: "",
    },
    flatNumber: {
      type: String,
      default: "",
    },
    flatBuilding: {
      type: String,
      default: "",
    },
    flatArea: {
      type: String,
      default: "",
    },
    flatFloor: {
      type: Number,
      default: 0,
    },
    flatMortgage: {
      type: String,
      default: "",
    },
    flatCost: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  mounted() {
    document.body.style.overflowX = "hidden";
  },
  methods: {
    getFlatCosts(flat) {
      return getReversPercentCost({ value: flat })
    }
}
};
</script>

<style scoped>
p {
  margin: 0;
}

.flat-card {
  display: flex;
  align-items: center;
  gap: 45px;
  padding: 60px 0 60px 0;
  border-top: 1px solid #e5e5e5;
  position: relative;
  z-index: 1;
}

.flats-card__new-price {
  color: #FF0020;
}

.flats-card__old-price {
  text-decoration: line-through;
  color: #291F1F;
  opacity: 0.6;
  font-size: 14px;
  margin-right: 10px;
}

.flat-card-wrapper {
  position: relative;
}

/* .flat-card__img-wrapper {
  position: relative;
} */

.flat-card__img-wrapper {
  position: relative;
  width: 198px;
  height: 202px;
  flex-shrink: 0;
}


.flat-card__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.flat-card__discount {
  position: absolute;
  left: 11px;
  top: 0px;
  z-index: 2;
}

.flat-card-wrapper::before {
  position: absolute;
  content: "";
  top: 0;
  left: -55px;
  transform: translateX(0);
  width: 100vw;
  height: 100%;
  z-index: 1;
}

.flat-card-wrapper:hover {
  cursor: pointer;
}

.flat-card-wrapper:hover::before {
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.flat-card-wrapper:hover .flat-card {
  border-top-color: transparent;
}

.flat-card-wrapper:hover .flat-card,
.flat-card-wrapper:hover + .flat-card-wrapper .flat-card {
  border-top-color: transparent;
}

.flat-card__content {
  flex: 1;
}

.flat-card__content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.flats-card__rooms-header {
  font-size: 18px;
  font-weight: 400;
  color: #291f1f;
  line-height: 100%;
  margin-bottom: 8px;
}

.flat-card__buttons {
  display: flex;
  gap: 15px;
}

.flats-card__rooms > span {
  font-size: 14px;
  opacity: 0.80;
}

.flats-card__area,
.flats-card__floor,
.flats-card__mortgage,
.flats-card__cost {
  position: relative;
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;
}

.flats-card__area,
.flats-card__floor,
.flats-card__mortgage,
.flats-card__cost > span:first-child {
  opacity: 0.6;
  font-size: 14px;
  font-weight: 400;
}

.flats-card__cost > span {
  font-weight: 700;
  flex-shrink: 0;
}

.flats-card__mortgage > span {
  flex-shrink: 0;
}

.flat-card__content-line {
  width: 100%;
  border-bottom: 1px dashed #e5e5e5;
}

@media (max-width: 1640px) {
  .flat-card-wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: -7%;
    right: -200px;
    background: transparent;
    z-index: 0;
    transition: all 0.3s ease;
    pointer-events: all;
  }
}

@media (max-width: 1280px) {
  .flat-card-wrapper::before {
    content: "";
    position: static;
  }
}

@media (max-width: 1280px) {
  .flat-card-wrapper::before {
    content: "";
    position: static;
  }
}

@media (max-width: 767px) {
  .flat-card-wrapper::before {
    content: "";
    position: static;
  }

  .flat-card {
    gap: 16px;
    padding: 24px 0 24px 0;
  }

  :deep(.docs-button__text) {
    display: none;
  }

  .flat-card__content-header {
    margin-bottom: 18px;
  }

  .flat-card__buttons {
    gap: 10px;
  }

  .flat-card__discount {
    position: absolute;
    left: -11px;
    top: -25px;
    z-index: 2;
  }

  .flats-card__rooms > span {
    font-size: 12px;
  }

  .flats-card__area,
  .flats-card__floor,
  .flats-card__mortgage,
  .flats-card__cost {
    display: flex;
    align-items: baseline;
    margin-bottom: 10px;
    position: relative;
  }

  .flats-card__area,
  .flats-card__floor,
  .flats-card__mortgage,
  .flats-card__cost > span:first-child {
    font-size: 14px;
  }

  .flats-card__area span:last-child,
  .flats-card__floor span:last-child,
  .flats-card__mortgage > span:last-child {
    font-size: 14px;
    font-weight: 500;
    flex-shrink: 0;
  }

  .flats-card__cost {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    position: relative;
  }

  .flats-card__cost > span:first-child {
    flex-shrink: 0;
  }

  .flat-card__content-line {
    flex: 1;
    margin: 0 8px;
  }

  .flats-card__old-price {
    font-size: 10px;
    text-decoration: line-through;
    color: #291F1F;
    opacity: 0.6;
    margin-right: 0;
    margin-left: 0;
    position: static;
  }

  .flats-card__new-price {
    font-size: 14px;
    color: #FF0020;
    display: block;
    width: 100%;
    text-align: right;
  }

  .flats-card__cost:has(.flats-card__new-price) {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .flats-card__cost:has(.flats-card__new-price) .flat-card__content-line {
    order: 1;
  }

  .flats-card__cost:has(.flats-card__new-price) .flats-card__old-price {
    order: 2;
  }

  .flats-card__cost:has(.flats-card__new-price) .flats-card__new-price {
    display: block;
    width: 100%;
    order: -1;
  }


  img {
    width: 80px;
    height: 80px;
  }

  .flat-card__img-wrapper {
    width: 80px;
    height: 80px;
  }
}
</style>
